export class URLish extends URL {
  removeOrigin = false
  removeSlash = false

  // Allow URLish to stand in for Location type
  // https://github.com/remix-run/history/blob/main/docs/api-reference.md#locationkey
  key = 'default'
  state = null

  constructor(url: string | URL, _base?: string | URL) {
    let base = _base
    try {
      new URL(url, base)
    } catch {
      base = 'http://doesnotexist.'
    }
    super(url, base)
    this.removeOrigin = base !== _base
    this.removeSlash =
      this.removeOrigin &&
      typeof url === 'string' &&
      !url.toString().startsWith('/')
  }

  toString() {
    let s = super.toString()
    if (this.removeOrigin) {
      s = s.substring(this.origin.length)
      if (this.removeSlash && s[0] === '/') {
        s = s.substring(1)
      }
    }
    return s
  }
}
